import React from 'react';
import url from 'url';
import PlayButton, { BUTTON_TYPE } from '../../PlayButton/PlayButton';
import { StyledExpandButton, StyledExpandButtonIcon } from './ExpandButton.styles';

const ExpandButton = ({ show, query, pathname, onExpand }) => {
    if (!show) {
        return null;
    }

    const newQuery = { ...query, relaterade: 'visa' };

    const attr = {
        href: url.format({
            pathname: pathname,
            query: newQuery,
            hash: 'mer-relaterat',
        }),
        onClick: (e) => {
            onExpand(e, newQuery);
        },
    };

    return (
        <StyledExpandButton>
            <PlayButton theme="default" {...attr} isCentered buttonType={BUTTON_TYPE.BUTTON}>
                <StyledExpandButtonIcon aria-hidden="true" /> Fler relaterade kategorier
            </PlayButton>
        </StyledExpandButton>
    );
};

export default ExpandButton;
